import { ref, unref } from 'vue';
import SalesTransactionDocumentsAPI from 'dashboard/api/salesTransactionDocuments';

const messageFrom = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

export function usePostSaleAnalysisPropertyDocuments({ id, t, notify }) {
  const documents = ref([]);
  const loading = ref(false);

  const load = async () => {
    if (!unref(id)) return [];
    loading.value = true;
    try {
      const response = await SalesTransactionDocumentsAPI.list(unref(id));
      documents.value = response?.data?.data || [];
      return documents.value;
    } catch (error) {
      documents.value = [];
      notify(messageFrom(error, t('POST_SALE.TOPICS.DOCUMENTS.LOAD_ERROR')));
      return [];
    } finally {
      loading.value = false;
    }
  };

  const download = async document => {
    try {
      const response = await SalesTransactionDocumentsAPI.signedUrl(
        unref(id),
        document.id
      );
      window.open(response.data.data.url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      notify(
        messageFrom(error, t('POST_SALE.TOPICS.DOCUMENTS.DOWNLOAD_ERROR'))
      );
    }
  };

  return { documents, download, load, loading };
}
